var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 119.169,
    height: 84.817,
    viewBox: "0 0 119.169 84.817",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_44462",
    "data-name": "Path 44462",
    d: "M130.2,148.429c-6.077-6.039-15.174-10.389-22.325-15.057-15.987-10.434-31.564-22.131-48.2-31.522q-1.015,8.1-2.035,16.206C49.443,101.74,42.079,84.856,35,68.019c19.527-.659,39.566-2.471,59.05-1.914A121.207,121.207,0,0,0,76.4,76.9c26.186,11.877,49.926,28.843,75.423,41.979",
    transform: "translate(-34 -65.026)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    opacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.49a4b04da95690652fa0d72ef466cf1a.svg";
export { ForwardRef as ReactComponent };